// Stub — will integrate @tempo/cookie consent
export const ConsentContextProvider = ({
	children,
}: {
	children?: React.ReactNode;
}) => <>{children}</>;
